const baseURL = 'https://hornosmx.com/';

export default baseURL;
